//#region imports
import customAxios from '../../utils/customAxios';
import { formatDateDDMMYYYY } from '../../utils/dateFormat';
import React, { useState, useEffect } from 'react';

import { DataGridPro } from '@mui/x-data-grid-pro';

import { Grid, Typography } from '@mui/material';

import { Stack } from '@mui/system';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { GlobalVariables } from '../../globalVar';
import { useTableLocale } from '../../hooks/useTableLocale';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const AssetLogsTableAxios = () => {
  const [assetLogData, setAssetLogData] = useState([]);
  const locale = useTableLocale();

  var logAssetId = localStorage.getItem('assetIdForLog');

  const endpoint = `${GlobalVariables.getURL()}listAssetLogs/${logAssetId}`;

  const getData = async () => {
    await customAxios
      .get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        const assetLogData = response.data;
        setAssetLogData(assetLogData);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  // Columnas
  const assetLogsColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'asset_mov_name',
      headerName: 'Tipo de Movimiento',
      width: 250,
    },
    {
      field: 'is_active',
      headerName: 'Estatus',
      width: 110,
      renderCell: (params) => {
        if (params.row.is_active === 'Activo') {
          return (
            <div>
              <span className="statusActive">{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="statusInactive">{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    {
      field: 'updated_at',
      headerName: 'Fecha de Actualización',
      width: 160,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            ['created_at', 'updated_at'].includes(col.field)
              ? formatDateDDMMYYYY(params.row[col.field])
              : params.row[col.field] || '-',
        },
  );

  const [selected, setSelected] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <div
          style={{
            height: '600%',
            width: '100%',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <DataGridPro
            localeText={locale.components.MuiDataGrid.defaultProps.localeText}
            pagination
            initialState={{
              sorting: {
                sortModel: [{ field: 'id', sort: 'desc' }],
              },
            }}
            rows={assetLogData}
            columns={assetLogsColumns}
            slots={{
              noRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  No hay logs de 'assets'.
                </Stack>
              ),
            }}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selected = assetLogData.filter((row) =>
                selectedIDs.has(row.id),
              );
              setSelected(selected);
              if (ids.length > 1) {
                const selectionSet = new Set(selectionModel);
                const result = ids.filter((s) => !selectionSet.has(s));

                setSelectionModel(result);
              } else {
                setSelectionModel(ids);
              }
            }}
            selectionModel={selectionModel}
            pageSize={5}
            rowsPerPageOptions={[5]}

            //getRowId={({id}) => id}
          />
        </div>
      </Grid>
      <Grid item xs={6}>
        <div className="logs-info-section">
          {selected.map((i) => (
            <Typography key={i} className="logs-info">
              <div className="divider"></div>
              <strong>Asset:</strong>
              <br />
              <span>Nombre:</span>&nbsp;{selected[0].asset_name}
              <br />
              <span>Sucursal:</span>&nbsp;{selected[0].site_name}
              <br />
              <span>Descripción:</span>&nbsp;{selected[0].description}
              <br />
              <div className="divider"></div>
              <strong>Información del log:</strong>
              <br />
              <span>Tipo de movimiento:</span>&nbsp;{selected[0].asset_mov_name}
              <br />
              <span>Fecha de creación:</span>&nbsp;{selected[0].created_at}
              <br />
              <span>Razón:</span>&nbsp;{selected[0].updated_reason}
              <br />
              <span>Fecha de actualización:</span>&nbsp;{selected[0].updated_at}
              <br />
              <div className="divider"></div>
            </Typography>
          ))}
        </div>
      </Grid>
    </Grid>
  );
};
